module.exports = __webpack_public_path__ + "static/media/product34.9d726ce3.jpg";